import { lazy } from "react"

const PartyListPage$$__react__lazy__component = lazy(() => 
    import("./PartyListPage__original__module.mjs")
        .then(module => module.get_$$PartyListPage$$PartyListPage$$react__component$$2yttimtto29ai())
        .then(component => ({ default: component }))
)

export const get_$$PartyListPage$$PartyListPage$$react__component$$2yttimtto29ai = () => PartyListPage$$__react__lazy__component